import { getAuthHeader } from '../../utils/utils';
import CommHandler from '../../utils/CommHandler';
import { config } from '../../config';

export interface Category {
  id: number;
  name: string;
  description?: string;
}

export const fetchCategories = async (): Promise<Category[]> => {
  try {
    const response = await CommHandler.request({
      url: `${config.apiBaseUrl}/artifact/category`,
      method: 'GET',
      headers: getAuthHeader,
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
};
